import React, { useState } from "react";
import { postDraft } from "@api/drafts";
import { Modal } from "@components/modal";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { getDraftPayloadValuesFromRequestContext } from "../../utils";
import { useHistory } from "react-router";
import { TEXTS } from "@utils";

interface Prop {
  closeSaveDraftModal: () => void;
  isShowDraft: boolean;
  data: any;
}

export const SaveDraftModal: React.FC<Prop> = ({
  isShowDraft,
  data,
  closeSaveDraftModal,
}) => {
  const history = useHistory();
  const [isSubmittingDraft, setIsSubmittingDraft] = useState(false);
  const handleSubmitDraft = () => {
    setIsSubmittingDraft(true);
    postDraft(getDraftPayloadValuesFromRequestContext(data))
      .then(() => {
        setIsSubmittingDraft(false);
        history.push("/dashboard/drafts");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let submitDraftText = isSubmittingDraft ? "Submitting..." : "Yes";

  return (
    <Modal isOpen={isShowDraft}>
      <Typography variant="body1" paragraph>
        {TEXTS.SAVE_REQUEST_AS_DRAFT}
      </Typography>
      <Box textAlign="right" mt={4}>
        <Button
          variant="outlined"
          color="primary"
          onClick={closeSaveDraftModal}
          disabled={isSubmittingDraft}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={handleSubmitDraft}
          style={{ marginLeft: "40px" }}
          disabled={isSubmittingDraft}
        >
          {submitDraftText}
        </Button>
      </Box>
    </Modal>
  );
};
